/*
 *
 * Script for contrast mode accessibility feature
 *
 */

import { setCookie, getCookie, deleteCookie } from './cookies';

export const contrastMode = () => {
    const contrastTogglers = document.querySelectorAll('.button-contrast-toggle');

    const isEnabled = () => getCookie('contrastmode') === 'true';

    const applyToDOM = (enabled) => {
        if (!document.body) return;
        document.body.classList.toggle('contrast-mode', enabled);
    };

    const setContrastButtonClasses = (enabled) => {
        if (!contrastTogglers || !contrastTogglers.length) return;

        contrastTogglers.forEach(button => {
            button.classList.toggle('--active', enabled);
        });
    };

    // initial load sync
    const enabled = isEnabled();
    applyToDOM(enabled);
    setContrastButtonClasses(enabled);

    if (!contrastTogglers || !contrastTogglers.length) return;

    contrastTogglers.forEach(button => {
        // Prevent binding twice if init runs twice
        if (button.dataset.contrastBound === 'true') return;
        button.dataset.contrastBound = 'true';

        button.addEventListener('click', (e) => {
            e.preventDefault();

            const enabledNext = !isEnabled();

            if (enabledNext) {
                setCookie('contrastmode', 'true', 7);
            } else {
                deleteCookie('contrastmode');
            }

            applyToDOM(enabledNext);
            setContrastButtonClasses(enabledNext);
        });
    });
};